import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function ProductDetailSkeleton({ isMobile }: { isMobile: boolean }) {
  return (
    <Box
      sx={{
        flex: 1,
        p: 3,
        display: "flex",
        gap: 3,
        flexDirection: isMobile ? "column" : "row",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : "56%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Skeleton
          variant="rectangular"
          height={isMobile ? 280 : 460}
          sx={{ borderRadius: "8px", bgcolor: "#f0f0f0" }}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          {[0, 1, 2, 3, 4].map((k) => (
            <Skeleton
              key={k}
              variant="rectangular"
              height={88}
              sx={{ flex: 1, borderRadius: "8px", bgcolor: "#f0f0f0" }}
            />
          ))}
        </Box>
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
        <Skeleton variant="text" width="60%" height={36} sx={{ bgcolor: "#f0f0f0" }} />
        <Skeleton variant="text" width="80%" height={22} sx={{ bgcolor: "#f0f0f0" }} />
        <Box sx={{ display: "flex", gap: 1 }}>
          {[0, 1, 2, 3].map((k) => (
            <Skeleton
              key={k}
              variant="circular"
              width={34}
              height={34}
              sx={{ bgcolor: "#f0f0f0" }}
            />
          ))}
        </Box>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{ borderRadius: "8px", bgcolor: "#f0f0f0" }}
        />
        <Skeleton
          variant="rectangular"
          height={44}
          sx={{ borderRadius: "4px", bgcolor: "#f0f0f0" }}
        />
        <Skeleton
          variant="rectangular"
          height={200}
          sx={{ borderRadius: "4px", bgcolor: "#f0f0f0" }}
        />
      </Box>
    </Box>
  );
}
